module.exports = __webpack_public_path__ + "img/ticket_boy.png";